import { defineMessages } from "react-intl";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";

import DateField from "@app/util/fieldModel/impl/DateField";
import FieldModel from "@app/util/fieldModel/impl/FieldModel";
import UserField from "@app/util/fieldModel/impl/UserField";

import CommonFieldName from "./CommonFieldName";
import HistoryField from "./impl/HistoryField";
import HistorySource from "./impl/HistorySource";

export enum EntityHistoryFieldName {
  FIELD = "field",
  DATE = CommonFieldName.UPDATED_AT,
  SOURCE = "source",
  USER = CommonFieldName.USER,
}

const displayNames = defineMessages<EntityHistoryFieldName>({
  [EntityHistoryFieldName.DATE]: {
    id: "entityHistory.field.date",
    defaultMessage: "Date",
    description: "Date field in entity history field model",
  },
  [EntityHistoryFieldName.FIELD]: {
    id: "entityHistory.field.field",
    defaultMessage: "Field",
    description: "Field field in entity history field model",
  },
  [EntityHistoryFieldName.SOURCE]: {
    id: "entityHistory.field.source",
    defaultMessage: "Source",
    description: "Source field in entity history field model",
  },
  [EntityHistoryFieldName.USER]: {
    id: "entityHistory.field.user",
    defaultMessage: "User",
    description: "User field in entity history field model",
  },
});

const entityHistoryFieldModel = new FieldModel([
  new HistoryField({
    displayName: displayNames[EntityHistoryFieldName.FIELD],
    displayOrder: 1,
    name: EntityHistoryFieldName.FIELD,
  }),
  new DateField({
    displayName: displayNames[EntityHistoryFieldName.DATE],
    displayOrder: 2,
    features: [FieldFeature.FILTERABLE],
    name: EntityHistoryFieldName.DATE,
  }),
  new HistorySource({
    displayName: displayNames[EntityHistoryFieldName.SOURCE],
    displayOrder: 3,
    name: EntityHistoryFieldName.SOURCE,
  }),
  new UserField({
    displayName: displayNames[EntityHistoryFieldName.USER],
    displayOrder: 4,
    features: [FieldFeature.FILTERABLE, FieldFeature.SUPPORTS_SET_FILTER, FieldFeature.OWNER_FIELD],
    name: EntityHistoryFieldName.USER,
    platformFilterNames: ["updatedBy.id"],
  }),
]);

export default entityHistoryFieldModel;
